export default __webpack_public_path__ + "static/media/dashboard.566c4f2d.svg";